/**
 * @module FE-CU15_戸締り確認画面_エリア
 */
import Header from '../../../../components/header/Header.vue';
import BreadCrumbList from '../../../../components/breadCrumb/List.vue';
import LockConfirmationArea from './components/LockConfirmationArea.vue';
import MobileFooter from '../../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../../components/pcPageTitle/PcPageTitle.vue';
import CONSTANTS from '../../../../constants';

const PAGE_ID = 'FE-CU15';

export default {
  name: 'LockedConfirmArea',
  components: {
    Header,
    BreadCrumbList,
    LockConfirmationArea,
    MobileFooter,
    PcPageTitle,
  },
  data() {
    return {
      title: '$vuetify.FECU15戸締り確認エリア.戸締り確認エリア',
      breadCrumbList: {
        firstText: '$vuetify.FECU07.トップ',
        firstRouter: '/top',
        secondText: '$vuetify.FECU08ホームセキュリティ画面.ホームセキュリティ',
        secondRouter: '/homeSecurity',
        thirdText: '$vuetify.FECU09対象地区詳細画面.対象地区詳細',
        thirdRouter: '/displayDistrictDetail',
        fourthText: '$vuetify.FECU10ユーザー警備操作画面.ユーザー警備操作',
        fourthRouter: '/userSecurityOperation',
        fifthText: '$vuetify.FECU13戸締り確認画面.戸締り確認',
        fifthRouter: '/lockConfirmation',
        sixthText: '$vuetify.FECU15戸締り確認エリア.戸締り確認エリア',
        sixthRouter: '/areaLockConfirmation',
      },
      panelTitle: {
        place: '',
        type: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [
        {
          id: 1,
          title: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.利用プラン',
          text: '',
        },
        {
          id: 2,
          title: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.お客様番号',
          text: '',
        },
        {
          id: 3,
          title: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.警備先名',
          text: '',
        },
        {
          id: 4,
          title: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.地区番号',
          text: '',
        },
        {
          id: 5,
          title: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.地区名',
          text: '',
        },
      ],
      planCode: [
        '$vuetify.コード.利用プランID.オンライン監視プラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
      ],
      securityAreaList: [],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU15戸締り確認エリア.戸締り確認エリア'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU15戸締り確認画面エリア.C0001'),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 戸締り確認詳細データ取得(APP_CU1501)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1501: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            if (!this.$store.state.gettingInFlag) {
              // apiData = {
              //   contentsInfo: {
              //     displayDistrictInfo: {
              //       usagePlan: 1,
              //       customerNumber: "51-1234567",
              //       securityDestinationName: "警備先1",
              //       districtSplitNumber: "0001",
              //       districtSplitName: "地区名1",
              //       displayDistrictNickname: "自宅",
              //     },
              //     sendCustomerNumber: "sendCustomerNumber",
              //     sendCommandKey: "sendCommandKey",
              //   },
              // };
            } else {
              // apiData = {
              //   contentsInfo: {
              //     displayDistrictInfo: {
              //       usagePlan: 1,
              //       customerNumber: "51-1234567",
              //       securityDestinationName: "警備先1",
              //       districtSplitNumber: "0001",
              //       districtSplitName: "地区名1",
              //       displayDistrictNickname: "自宅",
              //     },
              //     securityAreaList: [
              //       {
              //         securityAreaId: "1",
              //         securityAreaName: "玄関",
              //         securityAreaSensorList: [
              //           {
              //             securityAreaSensorNumber: "1",
              //             securityAreaSensorName: "玄関火災センサー",
              //             isSecurityAreaSensorAbnormalState: false,
              //           },
              //           {
              //             securityAreaSensorNumber: "2",
              //             securityAreaSensorName: "キッチン火災センサー",
              //             isSecurityAreaSensorAbnormalState: true,
              //           },
              //           {
              //             securityAreaSensorNumber: "3",
              //             securityAreaSensorName: "リビング火災センサー",
              //             isSecurityAreaSensorAbnormalState: false,
              //           },
              //           {
              //             securityAreaSensorNumber: "4",
              //             securityAreaSensorName: "寝室火災センサー",
              //             isSecurityAreaSensorAbnormalState: false,
              //           },
              //         ],
              //       },
              //       {
              //         securityAreaId: "2",
              //         securityAreaName: "リビング",
              //         securityAreaSensorList: [
              //           {
              //             securityAreaSensorNumber: "1",
              //             securityAreaSensorName: "キッチン火災センサー",
              //             isSecurityAreaSensorAbnormalState: false,
              //           },
              //           {
              //             securityAreaSensorNumber: "2",
              //             securityAreaSensorName: "寝室火災センサー",
              //             isSecurityAreaSensorAbnormalState: false,
              //           },
              //           {
              //             securityAreaSensorNumber: "3",
              //             securityAreaSensorName: "リビング火災センサー",
              //             isSecurityAreaSensorAbnormalState: true,
              //           },
              //           {
              //             securityAreaSensorNumber: "4",
              //             securityAreaSensorName: "玄関火災センサー",
              //             isSecurityAreaSensorAbnormalState: true,
              //           },
              //         ],
              //       },
              //     ],
              //   },
              // };
              this.securityAreaList = apiData.contentsInfo.securityAreaList;
            }

            this.panelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.対象地区',
              typeIsBefore: true,
            };
            this.displayAreaList[0].text =
              this.planCode[apiData.contentsInfo.displayDistrictInfo.usagePlan];
            this.displayAreaList[1].text = apiData.contentsInfo.displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text =
              apiData.contentsInfo.displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.メイン地区'
                : apiData.contentsInfo.displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitName;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @param {*} initData APP_CU1501のレスポンス
     * @returns レスポンス
     */
    APP_CO9915: async function (params, initData) {
      this.$_setLoading(true);

      let apiData = '';
      let method = 'post';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1501: {
          //         securityAreaId: '1',
          //         securityAreaName: '玄関',
          //         securityAreaSensorList: [
          //           {
          //             securityAreaSensorNumber: '1',
          //             securityAreaSensorName: '玄関火災センサー',
          //             isSecurityAreaSensorAbnormalState: false,
          //           },
          //           {
          //             securityAreaSensorNumber: '2',
          //             securityAreaSensorName: 'キッチン火災センサー',
          //             isSecurityAreaSensorAbnormalState: true,
          //           },
          //           {
          //             securityAreaSensorNumber: '3',
          //             securityAreaSensorName: 'リビング火災センサー',
          //             isSecurityAreaSensorAbnormalState: false,
          //           },
          //           {
          //             securityAreaSensorNumber: '4',
          //             securityAreaSensorName: '寝室火災センサー',
          //             isSecurityAreaSensorAbnormalState: false,
          //           },
          //         ],
          //       },
          //     },
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            this.panelTitle = {
              place: `- ${initData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.対象地区',
              typeIsBefore: true,
            };
            // "対象地区 - " +
            // initData.contentsInfo.displayDistrictInfo.displayDistrictNickname;
            this.displayAreaList[0].text =
              this.planCode[initData.contentsInfo.displayDistrictInfo.usagePlan];
            this.displayAreaList[1].text = initData.contentsInfo.displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text =
              initData.contentsInfo.displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              initData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU15戸締り確認エリア.対象地区詳細表示領域.メイン地区'
                : initData.contentsInfo.displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text =
              initData.contentsInfo.displayDistrictInfo.districtSplitName;

            let securityAreaSensorList = [];
            if (apiData.contentsInfo.commandExecutionResult.app_cu1501.securityAreaSensorList) {
              apiData.contentsInfo.commandExecutionResult.app_cu1501.securityAreaSensorList.forEach(
                function (securityAreaSensor) {
                  securityAreaSensorList.push({
                    securityAreaSensorNumber: securityAreaSensor.securityAreaSensorNumber,
                    securityAreaSensorName: securityAreaSensor.securityAreaSensorName,
                    isSecurityAreaSensorAbnormalState:
                      securityAreaSensor.isSecurityAreaSensorAbnormalState,
                  });
                }
              );
              securityAreaSensorList.sort(
                (a, b) => a.securityAreaSensorNumber - b.securityAreaSensorNumber
              );
              this.securityAreaList = [
                {
                  securityAreaId:
                    apiData.contentsInfo.commandExecutionResult.app_cu1501.securityAreaId === 'A'
                      ? '10'
                      : apiData.contentsInfo.commandExecutionResult.app_cu1501.securityAreaId,
                  securityAreaName:
                    apiData.contentsInfo.commandExecutionResult.app_cu1501.securityAreaName,
                  securityAreaSensorList: securityAreaSensorList,
                },
              ];
            }
          } else {
            // ブラウザバック時は表示しない
            if (this.$route.name === this.$options.name) {
              this.$_securityUnitExecutionResultDialog(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
          }
        })
        .finally(() => {
          // ブラウザバック時に遷移先で Loading が途切れるのを回避
          if (this.$route.name === this.$options.name) {
            this.$_setLoading(false);
          }
        });

      return apiData;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    // ホームセキュリティ非表示フラグ
    if (this.$store.state.disableHomeSecurityActive) {
      this.breadCrumbList.secondText = '$vuetify.FECU09対象地区詳細画面.対象地区詳細';
      this.breadCrumbList.secondRouter = '/displayDistrictDetail';
      this.breadCrumbList.thirdText = '$vuetify.FECU10ユーザー警備操作画面.ユーザー警備操作';
      this.breadCrumbList.thirdRouter = '/userSecurityOperation';
      this.breadCrumbList.fourthText = '$vuetify.FECU13戸締り確認画面.戸締り確認';
      this.breadCrumbList.fourthRouter = '/lockConfirmation';
      this.breadCrumbList.fifthText = '$vuetify.FECU15戸締り確認エリア.戸締り確認エリア';
      this.breadCrumbList.fifthRouter = '/areaLockConfirmation';
    }

    // FECU12警報確認画面 侵入フラグ
    if (this.$store.state.gettingInFlag) {
      this.title = '$vuetify.FECU14警報確認画面センサー.警報確認センサー';

      // ホームセキュリティ非表示フラグ
      if (this.$store.state.disableHomeSecurityActive) {
        this.breadCrumbList.secondText = '$vuetify.FECU09対象地区詳細画面.対象地区詳細';
        this.breadCrumbList.secondRouter = '/displayDistrictDetail';
        this.breadCrumbList.thirdText = '$vuetify.FECU10ユーザー警備操作画面.ユーザー警備操作';
        this.breadCrumbList.thirdRouter = '/userSecurityOperation';
        this.breadCrumbList.fourthText = '$vuetify.FECU12警報確認画面.警報確認';
        this.breadCrumbList.fourthRouter = '/alermConfirmation';
        this.breadCrumbList.fifthText = '$vuetify.FECU14警報確認画面センサー.警報確認センサー';
        this.breadCrumbList.fifthRouter = '/sensorWarningConfirmation';
      } else {
        this.breadCrumbList.fifthText = '$vuetify.FECU12警報確認画面.警報確認';
        this.breadCrumbList.fifthRouter = '/alermConfirmation';
        this.breadCrumbList.sixthText = '$vuetify.FECU14警報確認画面センサー.警報確認センサー';
        this.breadCrumbList.sixthRouter = '/sensorWarningConfirmation';
      }
    }

    this.securityAreaId = this.$store.state.securityAreaId;
    this.displayType = this.$store.state.displayType;
    if (this.securityAreaId == '' && this.displayType == 0) {
      this.$router.replace('/alermConfirmation');
      return;
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let param = '';
    let queries = {};
    if (!this.$store.state.gettingInFlag) {
      // 戸締り確認詳細データ取得
      param = '/api/areaLockConfirmation/init';
      // param = "post";

      queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        securityAreaId: this.securityAreaId === '10' ? 'A' : this.securityAreaId,
      };
    } else {
      // 戸締り確認詳細データ取得（侵入）
      param = '/api/areaLockConfirmation/getDetailDataIntrusion';
      // param = "post";

      queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        alarmType: 1, // 1:侵入
      };
    }

    let method = 'post';
    // APP_CU1501 APP_CU1502
    let apiData = await this.APP_CU1501(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined' && !this.$store.state.gettingInFlag) {
      let params = {};
      // 戸締り確認詳細データ取得
      params = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 8,
        alarmType: 0,
        districtSplitNumber: '',
        securityAreaId: queries.securityAreaId,
      };
      // APP_CO9915
      await this.APP_CO9915(params, apiData);
    }
  },
};
